export const sidebar = [
  {
    type: "accordion",
    title: "Manage Operator Accounts",
    content: [
      {
        title: "Roles and Templates",
        link: "/roles-and-templates",
        tag: "rolesAndTemplates",
      },
      {
        title: "Operator Accounts",
        link: "/operator-accounts",
        tag: "operatorAccounts",
      },

      // {
      // 	title: "Access and Permission",
      // 	link: "/user-access-permission",
      // 	tag: "accessPermission",
      // },
    ],
  },
  {
    type: "accordion",
    title: `Lockers`,
    content: [
      {
        title: `Lockers`,
        link: `/lockers`,
        tag: `lockers`,
      },
      {
        title: `Locker Fees`,
        link: `/locker-fees`,
        tag: `lockerFees`,
      },
      {
        title: `Locker Storage Fees`,
        link: `/locker-storage-fees`,
        tag: `lockerStorageFees`,
      },
      {
        title: `Assign to Branch`,
        link: `/assign-to-branch`,
        tag: `assignToBranch`,
      },
      {
        title: `Assign to Agent`,
        link: `/assign-to-agent`,
        tag: `assignToAgent`,
      },
      {
        title: `Locker Clean Up`,
        link: `/locker-clean-up`,
        tag: `lockerCleanUp`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Locker Users`,
    content: [
      {
        title: `Locker User Accounts`,
        link: `/locker-user-accounts`,
        tag: `lockerUserAccounts`,
      },
      // {
      // 	title: `Locker User Type`,
      // 	link: `/locker-user-types`,
      // 	tag: `lockerUserType`,
      // },
      {
        title: `Locker User Type`,
        link: `/locker-user-type`,
        tag: `lockerUserType`,
      },
      {
        title: `View Package History`,
        link: `/view-package-history`,
        tag: `viewPackageHistory`,
      },
      {
        title: `Broadcast Users`,
        link: `/broadcast-users`,
        tag: `broadcastUser`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Agents`,
    content: [
      {
        title: `Agents`,
        link: `/agents`,
        tag: `agents`,
      },
      {
        title: `Batch Upload`,
        link: `/batch-upload`,
        tag: `batchUpload`,
      },
      {
        title: `Broadcast Agents`,
        link: `/broadcast-agents`,
        tag: `broadcastAgents`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Partners`,
    content: [
      {
        title: `Partners`,
        link: `/partners`,
        tag: `partners`,
      },
      {
        title: `Partner Types`,
        link: `/partnerTypes`,
        tag: `partnerTypes`,
      },
      {
        title: `Branches`,
        link: `/branches`,
        tag: `branches`,
      },
      {
        title: `Payment Mode and Fees`,
        link: `/payment-mode-and-fees`,
        tag: `paymentModeAndFees`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Settings`,
    content: [
      {
        title: `Locker Time Limits`,
        link: `/locker-time-limits`,
        tag: `lockerTimeLimits`,
      },
      {
        title: `Storage Time Limits`,
        link: `/storage-time-limits`,
        tag: `storageTimeLimits`,
      },
      {
        title: `Locker User Templates`,
        link: `/locker-user-template`,
        tag: `lockerUserTemplates`,
      },
      {
        title: `Courier Templates`,
        link: `/courier-template`,
        tag: `courierTemplates`,
      },
      {
        title: `Locker Cleanup Templates`,
        link: `/locker-cleanup-template`,
        tag: `lockerCleanupTemplates`,
      },
      {
        title: `Wallet Top Up`,
        link: `/wallet-top-up`,
        tag: `walletTopUp`,
      },
    ],
  },
  {
    type: "accordion",
    title: "Campaigns",
    content: [
      // {
      // 	title: `Redemption Code Campaigns`,
      // 	link: `/mbox-redemption-code-campaigns`,
      // 	tag: `redemptionCode`,
      // },
      {
        title: `Behavioral Campaigns`,
        link: `/mbox-behavioral-campaigns`,
        tag: `behavioralCampaign`,
      },
      // {
      // 	title: `Coin Campaigns`,
      // 	link: `/mbox-coin-campaigns`,
      // 	tag: `mboxCoins`,
      // },
    ],
  },
  {
    type: "accordion",
    title: `Reports`,
    content: [
      {
        title: `Dropoff Status & History`,
        link: `/drop-off-status`,
        tag: `dropoffStatusHistory`,
      },
      {
        title: `Locker Occupancy`,
        link: `/locker-occupancy-report`,
        tag: `lockerOccupancy`,
      },
      {
        title: `Locker Full Alerts`,
        link: `/locker-full-report`,
        tag: `lockerFullAlerts`,
      },
      {
        title: `Locker Occupancy Peak Hours`,
        link: `/peak-hours-report`,
        tag: `lockerOccupancyPeakHoursReport`,
      },
      {
        title: `Package Dropoff Peak Hours`,
        link: `/peak-dropoff-report`,
        tag: `packageDropoffPeakHoursReport`,
      },
      // {
      //   title: `Shipout Status & History`,
      //   link: `/#`,
      // },
      {
        title: `Staytime in Locker`,
        link: `/staytime-in-locker`,
        tag: `staytimeInLocker`,
      },
      {
        title: `Partner Performance`,
        link: `/partner-performance-report`,
        tag: `partnerPerformance`,
      },
      {
        title: `Wallet History Report`,
        link: `/wallet-history-report`,
        tag: `partnerPerformance`,
      },
    ],
  },
  // {
  // 	type: "accordion",
  // 	title: `Summary Reports`,
  // 	content: [
  // 		{
  // 			title: `Payment on Delivery Summary`,
  // 			link: `/POD-report-summary`,
  // 			tag: `podSummaryReport`,
  // 		},
  // 		{
  // 			title: `Storage Rental Fees Summary`,
  // 			link: `/storage-fees-report-summary`,
  // 			tag: `storageFeesSummaryReport`,
  // 		},
  // 		{
  // 			title: `Overstay Fees Summary`,
  // 			link: `/overstay-report-summary`,
  // 			tag: `overstayFeesReportSummary`,
  // 		},
  // 	],
  // },
  {
    type: "accordion",
    title: `Operations Report`,
    content: [
      {
        title: `Suspicious Courier`,
        link: `/suspicious-courier-report`,
        tag: `suspiciousCourierOPReport`,
      },
      {
        title: `High Removal Couriers`,
        link: `/high-removal-courier`,
        tag: `highRemovalCouriers`,
      },

      {
        title: `Suspicious Courier Tagging`,
        link: `/suspicious-courier-numbers`,
        tag: `suspiciousCourierTagging`,
      },
      {
        title: `Unrecognized Waybill`,
        link: `/unrecognized-waybill`,
        tag: `unrecognizedWaybillOPReport`,
      },
      {
        title: `Declining Usage Finder`,
        link: `/declining-usage-report`,
        tag: `decliningUsageReport`,
      },
      {
        title: `Locker Clearing Summary`,
        link: `/locker-clearing-summary`,
        tag: `lockerClearingSummary`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Accounting`,
    content: [
      {
        title: `Collection Summary`,
        link: `/collection-summary`,
        tag: `collectionSummary`,
      },
      {
        title: `Package Status`,
        link: `/package-status`,
        tag: `packageStatus`,
      },
      {
        title: `Payment On Delivery`,
        tag: [`podReports`, `podSummaryReport`],
        link: ["/POD-report", "/POD-report-summary"],
        type: "accordion",
        content: [
          {
            title: `Payment On Delivery Report`,
            link: `/POD-report`,
            tag: `podReports`,
          },
          {
            title: `Payment On Delivery Summary Report`,
            link: `/POD-report-summary`,
            tag: `podSummaryReport`,
          },
        ],
      },
      {
        title: `Storage Rental Fees`,
        tag: [`storageRentals`, `storageFeesSummaryReport`],
        link: ["/storage-rental-fees", "/storage-fees-report-summary"],
        type: "accordion",
        content: [
          {
            title: `Storage Rental Fees Report`,
            link: `/storage-rental-fees`,
            tag: `storageRentals`,
          },
          {
            title: `Storage Rental Fees Summary Report`,
            link: `/storage-fees-report-summary`,
            tag: `storageFeesSummaryReport`,
          },
        ],
      },
      {
        title: `Overstay Fees`,
        link: ["/overstay-fees-report", "/overstay-report-summary"],
        tag: [`overstayFees`, `overstayFeesReportSummary`],
        type: "accordion",
        content: [
          {
            title: `Overstay Fees Report`,
            link: `/overstay-fees-report`,
            tag: `overstayFees`,
          },
          {
            title: `Overstay Fees Summary Report`,
            link: `/overstay-report-summary`,
            tag: `overstayFeesReportSummary`,
          },
        ],
      },
      {
        title: `Refund Request`,
        link: `/refund-request`,
        tag: `refundRequests`,
      },
    ],
  },
];
